import _ from 'underscore';
import { keyCode } from './keyCode';
import type { KeyCode, KeyCodeName } from './keyCode';

// The key is capitalized to be compatible with http://www.w3.org/TR/DOM-Level-3-Events-code.

// Generate a readonly output.
// Theoretically the properties should be named as keyCode (numeric) and code (string) to be
// aligned with KeyboardEvent#keyCode and KeyboardEvent#code, but that would be confusing for people
// that are not familiar with this story, and when KeyboardEvent#code is supported by the browser,
// this component should be deprecated altogether, so let's use easy-to-understand property names
// here.

export type KeyName = Readonly<Record<number, KeyCodeName>>;

const uniqueValues = (object: KeyCode): KeyCode => _.object(_.unique(_.pairs(object), o => o[1])) as unknown as KeyCode;

/**
 * Look up keyName (KeyboardEvent#code, string) with keyCode (KeyboardEvent#keyCode, numeric).
 * @example   keyName[9] === 'Tab'
 * @return    {string}  The name (KeyboardEvent#code, string)
 */
export const keyName: KeyName = Object.create(
  Object.prototype,
  _.mapObject(_.invert(uniqueValues(keyCode)), (val: string) => ({
    enumerable: true,
    value: val as KeyCodeName,
    writable: false
  }))
);
